// eslint-disable-next-line @typescript-eslint/typedef
export const FragmentLoaderEvents = {
  fragments: {
    fragmentLoaded: 'fragmentLoader.fragments.fragmentLoaded',
    fragmentLoadingStarted: 'fragmentLoader.fragments.fragmentLoadingStarted',
    fragmentLoadingAborted: 'fragmentLoader.fragments.fragmentLoadingAborted',
    fragmentLoadingError: 'fragmentLoader.fragments.fragmentLoadingError',
    fragmentHistoryReadyForPrint: 'fragmentLoader.fragments.fragmentHistoryReadyForPrint',
  },
} as const;

export type TFragmentLoaderEvents = {
  [FragmentLoaderEvents.fragments.fragmentHistoryReadyForPrint]: { historyString: string };
};
